import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

function getStoredLocale(): 'en' | 'de' {
  if (typeof window === 'undefined') return 'en'
  const stored = localStorage.getItem('airies_lang')
  if (stored === 'en' || stored === 'de') return stored
  const cookieMatch = document.cookie.match(/(?:^|;\s*)airies_lang=([^;]+)/)
  const cookieValue = cookieMatch?.[1]
  if (cookieValue === 'en' || cookieValue === 'de') return cookieValue
  return 'en'
}

export function formatTimeAgo(isoDate: string, locale?: 'en' | 'de'): string {
  const date = new Date(isoDate)
  const now = new Date()
  const diffMs = now.getTime() - date.getTime()
  const diffMins = Math.floor(diffMs / 60000)
  const diffHours = Math.floor(diffMs / 3600000)
  const diffDays = Math.floor(diffMs / 86400000)
  const currentLocale = locale || getStoredLocale()
  const isGerman = currentLocale === 'de'

  if (diffMins < 1) return isGerman ? 'Gerade eben' : 'Just now'
  if (diffMins < 60) {
    if (isGerman) return `vor ${diffMins} ${diffMins === 1 ? 'Minute' : 'Minuten'}`
    return `${diffMins} ${diffMins === 1 ? 'minute' : 'minutes'} ago`
  }
  if (diffHours < 24) {
    if (isGerman) return `vor ${diffHours} ${diffHours === 1 ? 'Stunde' : 'Stunden'}`
    return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'} ago`
  }
  if (diffDays < 7) {
    if (isGerman) return `vor ${diffDays} ${diffDays === 1 ? 'Tag' : 'Tagen'}`
    return `${diffDays} ${diffDays === 1 ? 'day' : 'days'} ago`
  }
  return date.toLocaleDateString(isGerman ? 'de-DE' : 'en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}
